"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftChannelEnum = void 0;
var DraftChannelEnum;
(function (DraftChannelEnum) {
    DraftChannelEnum["Mail"] = "M";
    DraftChannelEnum["Sms"] = "S";
    DraftChannelEnum["InternalNote"] = "In";
})(DraftChannelEnum = exports.DraftChannelEnum || (exports.DraftChannelEnum = {}));
